import { useEffect } from 'react';
import { useStore } from 'react-redux';

export default function useExtendedEffect(effect, deps) {
  const store = useStore();

  const runSideEffects = () => !store.getState().stateHistory.isStateReset;
  useEffect(() => {
    return effect(runSideEffects);
  }, deps);
}
